<template>
  
  <PostFeed :feedSettings="feedSettings" />
  
</template>

<script>

import PostFeed from './components/PostFeed.vue'

export default {
  props: {
    feedSettings: {
      type: Object
    }
  },
  components: {
    PostFeed
  }
}
</script>

<style lang="scss">

</style>
